import React from 'react';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';

const ModalTransition = props => {
  return /*#__PURE__*/React.createElement(ExitingPersistence, {
    appear: true
  }, props.children);
};

export default ModalTransition;